import React, { useEffect, useState } from 'react'
import "./joinRibbon.css"
import { Button } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
import useWindowDimensions from '../../customHooks/useWindowDimensions';
import BookNowBtn from '../bookNowBtn/BookNowBtn';

function JoinRibbon() {
    const { height, width } = useWindowDimensions();
    const navigate = useNavigate()
    const handle_verifyPayment = (data) => {
        var options = {
            "key": "rzp_test_T8DHcG7Et2DgtJ", // Enter the Key ID generated from the Dashboard
            "amount": data.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "Global Trade Academy", //your business name
            "description": "Training Fee",
            "image": "https://example.com/your_logo",
            "order_id": data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": async function (response) {
                // alert(response.razorpay_payment_id);
                // alert(response.razorpay_order_id);
                // alert(response.razorpay_signature)
                const body = {
                    ...response
                }
                await axios.post(process.env.REACT_APP_SERVER + "/api/v1/razorpay/order/verify", body).then((res) => {
                    if (res?.data?.success) {
                        console.log(res?.data, "y");
                        // let payent_id = res?.data?.data?.id
                        localStorage.setItem("payent_id", res?.data?.data?.razorpay_payment_id)
                        navigate("/receipt")
                    } else {
                        alert("Transaction Failed")
                    }
                })
            },
            "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                "name": "", //your customer's name
                "email": "",
                "contact": ""  //Provide the customer's phone number for better conversion rates 
            },
            "notes": {
                "address": "Razorpay Corporate Office"
            },
            "theme": {
                "color": "#3399cc"
            }
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.on('payment.failed', function (response) {
            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
        });
        rzp1.open();

    }




    const handle_payment = async () => {
        try {
            const body = {
                "amount": (99 * 100),
                "receipt": "salehan",
                "notes": [
                    { "note1": "ok1" },
                    { "note2": "ok2" },
                    { "note3": "ok2" }
                ]
            }
            await axios.post(process.env.REACT_APP_SERVER + "/api/v1/razorpay/order/create", body).then((res) => {
                console.log(res.data, "x");
                handle_verifyPayment(res.data.data)
            })
        } catch (error) {

            alert("Under Development")
        }
    }
    const [today, setToday] = useState(new Date())
    useEffect(() => {
        var refreshIntervalId = setInterval(() => {
            setToday(new Date())
        }, 1000);

        return () => {
            clearInterval(refreshIntervalId);
        }
    }, [])


    return (
        <div className='joinRibbon'>
            <div className='content'>
                {!(localStorage.getItem("createAcc")? true:false) &&<div className='offer-text-wp'>
                    <div className='price-wp'>
                        <p>
                            Ony at <span className='offer-price'>₹299</span> <span>₹3,500
                                <img src='../../../img/red_stroke.png' /></span>
                        </p>
                        <p className='no-line-break'>
                            
                            <b>{25 - today?.getHours()}hr&nbsp;
                            {59 - today?.getMinutes()}min&nbsp;
                            {59 - today?.getSeconds()}sec
                            </b>
                            </p>
                    </div>
                </div>}
                <div className='arrow-gif-wp'>
                    <img className='arrow-gif' src='https://i.pinimg.com/originals/d3/7a/f4/d37af41b9ac45cff5de420eb071a65dc.gif' />
                </div>
                <div className='join-btn-wp'>
                    <BookNowBtn />
                </div>
            </div>
        </div>
    )
}

export default JoinRibbon